import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { baseurl, imageUrl } from "../Baseurl"; 
import SellerNavbar from "../component/SellerNavbar";

const OrderDetail = () => {
  const { orderid } = useParams();
  const sellerId = localStorage.getItem("seller_id");
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);


    const [showModal, setShowModal] = useState(false);
const [deliveryType, setDeliveryType] = useState("");
const [trackingLink, setTrackingLink] = useState("");


  useEffect(() => {
    if (!sellerId || !orderid) {
      Swal.fire("Error", "Missing seller ID or order ID", "error");
      return;
    }

    const fetchOrder = async () => {
      try {
        const res = await axios.get(`${baseurl}getOrderBySellerIdAndUniqueId/${sellerId}/${orderid}`);
        if (res.data.success) {
          setOrder(res.data.order);
        } else {
          Swal.fire("Error", "Order not found", "error");
        }
      } catch (err) {
        console.error(err);
        Swal.fire("Error", "Failed to load order", "error");
      } finally {
        setLoading(false);
      }
    };

    fetchOrder();
  }, [orderid, sellerId]);

  if (loading) return <p>Loading...</p>;
  if (!order) return <p>Order not found</p>;


  const updateOrderStatus = async (newStatus) => {
    const payload = {
      order_id: order.order_unique_id,
      seller_id: sellerId,
      status: newStatus,
    };
  
    console.log("Sending order status update data:", payload); // ✅ Log the payload
  
    try {
      const res = await axios.post(`${baseurl}updateOrderStatusBySeller`, payload);
  
      if (res.data.success) {
        Swal.fire("Success", `Order marked as ${newStatus}`, "success");
        setOrder((prev) => ({ ...prev, order_status: newStatus }));
        window.location.reload();
      } else {
        Swal.fire("Error", res.data.message || "Failed to update status", "error");
      }
    } catch (err) {
      console.error(err);
      Swal.fire("Error", "Something went wrong", "error");
    }
  };



  
const updateOrderStatusFinal = async (newStatus) => {
  const payload = {
    order_id: order.order_unique_id,
    seller_id: sellerId,
    status: newStatus,
    delivery_type: deliveryType,
    ...(deliveryType === "seller" && { tracking_link: trackingLink }),
  };

  console.log("Sending order status update data:", payload);

  try {
    const res = await axios.post(`${baseurl}updateOrderStatusBySellerFinal`, payload);

    if (res.data.success) {
      Swal.fire("Success", `Order marked as ${newStatus}`, "success").then(() => {
        window.location.reload();
      });
    } else {
      Swal.fire("Error", res.data.message || "Failed to update status", "error");
    }
  } catch (err) {
    console.error(err);
    Swal.fire("Error", "Something went wrong", "error");
  }
};

  

  return (
    <>
      <SellerNavbar/>
      <div className="container my-4">
        <div className="d-flex">
          <h3 className="text-center mb-4">Order Details</h3>
          <div>
           
          </div>
        </div>


       
       <div className="order-progress">
  <div className={`step ${["Pending", "Processing", "Out For Delivery", "Delivered"].includes(order.matched_cart_items[0]?.status_by_seller) ? "active" : ""}`}>
    <div className="circle">1</div>
    <div className="label">Active</div>
  </div>
  <div className={`step ${["Processing", "Out For Delivery", "Delivered"].includes(order.matched_cart_items[0]?.status_by_seller) ? "active" : ""}`}>
    <div className="circle">2</div>
    <div className="label">Processing</div>
  </div>
  <div className={`step ${["Out For Delivery", "Delivered"].includes(order.matched_cart_items[0]?.status_by_seller) ? "active" : ""}`}>
    <div className="circle">3</div>
    <div className="label">Ready For Delivery</div>
  </div>
  <div className={`step ${order.matched_cart_items[0]?.status_by_seller === "Delivered" ? "active" : ""}`}>
    <div className="circle">4</div>
    <div className="label">Delivered</div>
  </div>
</div>





        <div className="card shadow p-4">
          <div className="mb-3 d-flex justify-content-between">
            <div className="text-start">
              <h5>Order ID: {order.order_unique_id}</h5>
              <p>Placed on: {new Date(order.created_at).toLocaleString()}</p>
              <p>Payment Method: {order.payment_method}</p>
            </div>
            <div className="text-end">
              <h6>Shipping To:</h6>
              <p>
                <strong>{order.shipping_address.full_name}</strong>
                <br />
                {order.shipping_address.address_line1}
                <br />
                {order.shipping_address.city}, {order.shipping_address.state} -{" "}
                {order.shipping_address.postal_code}
                <br />
                {order.shipping_address.country}
                <br />
                Phone: {order.shipping_address.phone_number}
              </p>
            </div>
          </div>

          <hr />

          <table className="custom-table">
            <thead className="table-light">
              <tr>
                <th>#</th>
                <th>Item</th>
                <th>Qty</th>
                <th>Price (₹)</th>
                <th>GST</th>
                <th>Delivery</th>
                <th>Total (₹)</th>
              </tr>
            </thead>
            <tbody>
              {order.matched_cart_items.map((item, index) => (
                <tr key={item.cart_id}>
                  <td>{index + 1}</td>
                  <td>
                    <img
                      src={`${imageUrl}listing/${item.image}`}
                      alt={item.title}
                      width="50"
                      className="me-2"
                    />
                    {item.title}
                  </td>
                  <td>{item.quantity}</td>
                  <td>{item.price}</td>
                  <td>{item.gst}%</td>
                  <td>
                    ₹{item.delivery_charge} <br />
                    <small>({item.delivery_method})</small>
                  </td>
                  <td>₹{parseFloat(item.total_with_delivery).toFixed(2)}</td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* <div className="text-end">
            <h5>Subtotal: ₹{parseFloat(order.total).toFixed(2)}</h5>
            <h5>Discount: ₹{parseFloat(order.discount).toFixed(2)}</h5>
            <h4 className="fw-bold">
              Grand Total: ₹
              {order.matched_cart_items.reduce(
                (acc, item) => acc + parseFloat(item.total_with_delivery),
                0
              ).toFixed(2)}
            </h4>
          </div> */}


<div className="text-end mt-4">
  <div className="mb-3 border-bottom pb-2">
    <h6>Current Status: <strong>{order.matched_cart_items[0]?.status_by_seller || "Pending"}</strong></h6>

    {(!order.matched_cart_items[0]?.status_by_seller || order.matched_cart_items[0]?.status_by_seller === "Pending") && (
      <button
        className="btn btn-sm btn-outline-primary"
        onClick={() => updateOrderStatus("Processing")}
      >
        Mark as Processing
      </button>
    )} 
    {order.matched_cart_items[0]?.status_by_seller === "Processing" && (
  <button
    className="btn btn-sm btn-outline-success"
    onClick={() => setShowModal(true)}
  >
    Mark as Out For Delivery
  </button>
)}

{order.matched_cart_items[0]?.status_by_seller === "Out For Delivery" && (
  <button
    className="btn btn-sm btn-outline-primary"
    onClick={() => updateOrderStatus("Delivered")}
  >
    Mark as Delivered
  </button>
)}

{showModal && (
  <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
    <div className="modal-dialog modal-dialog-centered">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Select Delivery Type</h5>
          <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
        </div>
        <div className="modal-body">
          <select
            className="form-select mb-3"
            value={deliveryType}
            onChange={(e) => setDeliveryType(e.target.value)}
          >
            <option value="">Select Delivery Type</option>
            <option value="seller">Fulfilled by Seller</option>
            <option value="techspares">Fulfilled by TechsparesOnline</option>
          </select>

          {deliveryType === "seller" && (
            <input
              type="text"
              className="form-control"
              placeholder="Enter tracking link"
              value={trackingLink}
              onChange={(e) => setTrackingLink(e.target.value)}
            />
          )}
        </div>
        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={() => setShowModal(false)}>
            Cancel
          </button>
          <button
            className="btn btn-primary"
            onClick={() => {
              updateOrderStatusFinal("Out For Delivery");
              setShowModal(false);
            }}
            disabled={deliveryType === "seller" && trackingLink.trim() === ""}
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  </div>
)}




  </div>
</div>



        </div>
      </div>
    </>
  );
};

export default OrderDetail;
